import { gql } from "@apollo/client";

export const GET_UMS_COPIED_CUSTOMERS_LIST_PAGED = gql`
    query GetUmsCopiedCustomersListPaged(
        $limit: Int!
        $offset: Int!
        $where: ums_customers_bool_exp!
        $orderBy: [ums_customers_order_by!]
    ) {
        customers: ums_customers(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
            id
            name
            number
            iscopied
        }
        customers_aggregate: ums_customers_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const GET_UMS_COPY_CUSTOMER_PROCESSES_OVERVIEW_PAGED = gql`
    query GetUmsCopyCustomerProcessesOverviewPaged(
        $limit: Int!
        $offset: Int!
        $where: common_v_copy_customer_jobs_bool_exp!
    ) {
        processes: common_v_copy_customer_jobs(
            where: $where
            order_by: { created_at: desc }
            limit: $limit
            offset: $offset
        ) {
            customerid
            name
            number
            status
            progress_percent
            username
            error_message
            from_env
            created_at
        }
        processes_aggregate: common_v_copy_customer_jobs_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const SUBSCRIBE_UMS_COPY_CUSTOMER_PROCESSES_OVERVIEW_PAGED = gql`
    subscription SubscribeUmsCopyCustomerProcessesOverviewPaged($where: common_v_copy_customer_jobs_bool_exp!) {
        processes: common_v_copy_customer_jobs(where: $where) {
            customerid
            status
            progress_percent
        }
    }
`;

export const GET_COPY_CUSTOMER_SOURCE_CUSTOMERS = gql`
    query GetCopyCustomerSourceCustomers {
        prodCustomers: ums_v_prod_customers(order_by: { name: asc }) {
            id
            name
            number
            subdomain
        }
        testCustomers: ums_v_test_customers(order_by: { name: asc }) {
            id
            name
            number
            subdomain
        }
        devCustomers: ums_v_dev_customers(order_by: { name: asc }) {
            id
            name
            number
            subdomain
        }
    }
`;

export const GET_COPY_CUSTOMER_JOB_STATUSES = gql`
    query GetCopyCustomerJobStatuses {
        copyJobs: common_v_copy_customer_jobs(
            distinct_on: customerid
            order_by: [{ customerid: asc }, { created_at: desc }]
        ) {
            customerid
            status
            created_at
        }
    }
`;

export const UPDATE_GENERALSETTINGS = gql`
    mutation UpdateGeneralsettings($inspversion: String, $input: ums_generalsettings_set_input) {
        updategeneralsettings: update_ums_generalsettings(where: { key: { _eq: $inspversion } }, _set: $input) {
            affected_rows
        }
    }
`;

export const GET_GENERALSETTINGS = gql`
    query GetGeneralSettingsVersion {
        ums_generalsettings(where: { key: { _in: ["INSP.MINVERSION", "INSP.CURRENTVERSION"] } }) {
            id
            key
            value
        }
    }
`;
